import TemasSeleccionados from "../../view/components/RegistroUsuarios/Clasificacion/EditarTemasArea/TemasSeleccionados";
import withTemasAreaDocente from "../../hoc/Docentes/withTemasAreaDocente";
import withOrdenarTemasDocente from "../../hoc/Docentes/withOrdenarTemasDocente";
import withEliminarTemasDocente from "../../hoc/Docentes/withEliminatTemasDocente";
import withEditarTemasSeleccionados from "../../hoc/Docentes/withEditarTemasSeleccionados";

export default withEditarTemasSeleccionados(TemasSeleccionados);